import { type LinearConfigurationDTO } from "~/features/configurator/Linear/dtos";
import type { ConfiguratorUpdateCommand } from "~/features/configurator/common/api/configuratorCommands";
import { postConfiguratorCommand } from "~/features/configurator/common/api/configuratorCommandApi";

export function sendCarriage(data: ConfiguratorUpdateCommand): Promise<LinearConfigurationDTO> {
  return postConfiguratorCommand("/carriages/getconfig", data, "sending carriage update");
}
